import { render } from "./CommunityForm.vue?vue&type=template&id=21fc0d29&scoped=true"
import script from "./CommunityForm.vue?vue&type=script&lang=js"
export * from "./CommunityForm.vue?vue&type=script&lang=js"

import "./CommunityForm.vue?vue&type=style&index=0&id=21fc0d29&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fc0d29"]])

export default __exports__